<ion-searchbar
  debounce="800"
  placeholder="Buscar un producto"
  [(ngModel)]="searchValue"
  (ionInput)="search($event)"
  class="custom-searchbar"
>
</ion-searchbar>
